exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-19c4b900]{cursor:pointer}.img-wrapper[data-v-19c4b900]{position:relative;width:100%;height:100%}.img-wrapper .fa-stack[data-v-19c4b900]{position:absolute;top:4px;left:0}", ""]);

// exports
